import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem('admin_token');
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}');
  const isPartner = (user.role || '').toUpperCase() === 'PARTNER';

  if (isPartner) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        token && !isPartner ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default ProtectedRoute;
